import React from 'react';
import { TableCell, TableRow } from '../../../../../components/ui/table';

function TableSkeleton() {
  return (
    <TableRow>
      <TableCell>
        <div className="w-10 h-10 rounded-full bg-muted animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-4 w-32 bg-muted rounded animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-5 w-16 bg-muted rounded-full animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-4 w-16 bg-muted rounded animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-5 w-16 bg-muted rounded-full animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-5 w-20 bg-muted rounded-full animate-pulse" />
      </TableCell>
      <TableCell className="text-right">
        <div className="h-4 w-6 bg-muted rounded animate-pulse ml-auto" />
      </TableCell>
      <TableCell className="text-right">
        <div className="h-4 w-6 bg-muted rounded animate-pulse ml-auto" />
      </TableCell>
      <TableCell>
        <div className="h-2 w-24 bg-muted rounded-full animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </TableCell>
      <TableCell>
        <div className="h-8 w-8 bg-muted rounded animate-pulse" />
      </TableCell>
    </TableRow>
  );
}

export default TableSkeleton;
